import API from 'app/api';
import { extractData } from 'app/api/requests/parsers/response';

const login = ({ username, password, sessionId, ...rest }) =>
  API.Crapi.login({
    account: username,
    password,
    session_id: sessionId,
    ...rest,
  });

const register = ({ username, sessionId, ...rest }) =>
  API.Crapi.registration({
    email: username,
    session_id: sessionId,
    ...rest,
  });

const checkCaptcha = ({ formType, sessionId }) =>
  API.Crapi.checkCaptcha({
    form_type: formType,
    session_id: sessionId,
  }).then(extractData);

export { login, register, checkCaptcha };
